import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { SelectOption } from 'QuoteApp/services/endpoints/GetConfig';
import { FlexiblePaymentFrequency } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import { FormInput } from 'Shared/components';

import { PriceCustomizerFormValues } from '../domain';

type FrequencySelectorType = {
  isLoading?: boolean;
  options: Array<SelectOption<string>>;
  onChange?: (value: FlexiblePaymentFrequency) => void;
};

export const FrequencySelector: FC<FrequencySelectorType> = ({
  isLoading,
  options,
  onChange,
}) => {
  const { handleBlur, setFieldValue, values } = useFormikContext<
    PriceCustomizerFormValues
  >();

  const handleChange = (selectedValue: string) => {
    setFieldValue('frequency', selectedValue);

    if (onChange) {
      onChange(selectedValue as FlexiblePaymentFrequency);
    }
  };

  const transformOptions = (
    options: Array<SelectOption<string>>
  ): { [value: string]: string } => {
    return options.reduce((acc, option) => {
      acc[option.value] = option.label;
      return acc;
    }, {} as { [value: string]: string });
  };

  return (
    <FormInput
      data-testid="payflex-frequency"
      variant="selectAutocomplete"
      name="frequency"
      label="Payment frequency"
      value={values.frequency}
      disabled={isLoading}
      options={transformOptions(options)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
